import * as React from "react";
import "animate.css/animate.min.css";
import LottieAnimation from "../components/lootie/Lottie";
import Layout from "../components/layout/layout";
import HomePageHero from "../sections/homepageHero/hompageHero";
import SectionWithIcons from "../sections/sectionWithIcons/sectionWithIcons";
import BlocksWithIconsTwo from "../sections/blocksWithIconsTwo/BlocksWithIconsTwo";
import SectionWithText from "../sections/sectionWithText/sectionWithText";
import Products from "../sections/products/Products";
import Community from "../sections/community/community";
import LatestNews from "../sections/latestNews/LatestNews";
import Blocks from "../sections/blocks/blocks";
import CustomLink from "../components/customLink/CustomLink";
import FadeIn from "../components/fade/fade";

import CompatibilityJson from "../json/Compatibility.json";
import SecurityArchitectureJson from "../json/Security_Architecture.json";

import LercStandardJson from "../json/LERC20_Integration.json";
import RealTimeFreezingJson from "../json/Real-time_Freezing.json";
import EfficientJson from "../json/Effiecient_evidence-based.json";
import TimelyRecoveryJson from "../json/Timely_recovery.json";
import FeesOnlyChargedJson from "../json/Fees_only_Charged.json";
import AdvancedExploitJson from "../json/Advanced_Exploit.json";
import { Helmet } from "react-helmet";

const sectionWithIconsData = {
  sectionColor: "green",
  titleMaxWidth: "891px",
  title:
    "Reinforce your protocol security",
  text: "Lossless Protocol provides on-chain fail-safes for your token contracts and mitigation tools while Aegis provides real-time monitoring of all your mission critical contracts.",
  textColor:'white',
  items: [
    {
      icon: <LottieAnimation animationJson={LercStandardJson} />,
      title: "Seamless LERC-20 standard integration",
    },
    {
      icon: <LottieAnimation animationJson={RealTimeFreezingJson} />,
      title: "Automated real-time freezing of suspicious transactions",
    },
    {
      icon: <LottieAnimation animationJson={EfficientJson} />,
      title: "Efficient and evidence-based resolution mechanism",
    },
    {
      icon: <LottieAnimation animationJson={TimelyRecoveryJson} />,
      title: "Timely recovery of stolen funds",
    },
    {
      icon: <LottieAnimation animationJson={FeesOnlyChargedJson} />,
      title: "Fees only charged on prevented financial loss",
    },
    {
      icon: <LottieAnimation animationJson={AdvancedExploitJson} />,
      title: "Advanced exploit identification and mitigation tools",
    },
  ],
};

const sectionWithTwoBlocksData = {
  title: "<span>LERC-20</span> Token Standard",
  text: "The technology behind Lossless Protocol",
  align: "center",
  items: [
    {
      title: "Compatibility",
      text: "LERC-20 is a unique extension of the widely-known and trusted ERC-20 standard. The methods and interface are fully compatible with all DeFi primitives.",
      icon: <LottieAnimation animationJson={CompatibilityJson} />,
    },
    {
      title: "Architecture",
      text: "Adoption of the LERC-20 standard enhances token security architecture without compromising prior integrations or disrupting existing workflows.",

      icon: <LottieAnimation animationJson={SecurityArchitectureJson} />,
    },
  ],
  button: (
    <CustomLink
      text="Documentation"
      size="small"
      type="blue"
      url="https://docs.lossless.io/protocol/"
      blank={true}
    />
  ),
};

const sectionWithTextData = {
  title:
    "<span>Leaders</span> in Web3 security",
  titleFontSize: "4.7rem",
  text: [
    "Adding layers of protection to your on-chain infrastructure is easy with Lossless Protocol and Aegis.",
    "We provide customizable end-to-end solutions for exploit monitoring, prevention and mitigation.",
  ],
  button: {
    type: "blue",
    size: "small",
    text: "About us",
    url: "/about/",
    internal: true,
  },
};

const IndexPage = () => {
  return (
    <Layout pageTitle="Restoring Trust in Web3 Security | Lossless">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Restoring Trust in Web3 Security | Lossless</title>
        <meta
          name="title"
          content="Restoring Trust in Web3 Security | Lossless"
        />
        <meta
          name="description"
          content="Lossless is a leader in Web3 security architecture and exploit mitigation tools. By combining community-driven threat identification strategies with a unique stake-based reporting system, Lossless protocol efficiently tracks suspicious on-chain activity, freezing malicious transactions and recovering stolen funds."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://lossless.io/" />
        <meta
          property="og:title"
          content="Restoring Trust in Web3 Security | Lossless"
        />
        <meta
          property="og:description"
          content="Lossless is a leader in Web3 security architecture and exploit mitigation tools. By combining community-driven threat identification strategies with a unique stake-based reporting system, Lossless protocol efficiently tracks suspicious on-chain activity, freezing malicious transactions and recovering stolen funds."
        />
        <meta property="og:image" content="https://lossless.io/og.png" />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://lossless.io/" />
        <meta
          property="twitter:title"
          content="Restoring Trust in Web3 Security | Lossless"
        />
        <meta
          property="twitter:description"
          content="Lossless is a leader in Web3 security architecture and exploit mitigation tools. By combining community-driven threat identification strategies with a unique stake-based reporting system, Lossless protocol efficiently tracks suspicious on-chain activity, freezing malicious transactions and recovering stolen funds."
        />
        <meta property="twitter:image" content="https://lossless.io/og.png" />
      </Helmet>
      <HomePageHero></HomePageHero>
      <Blocks />
      <FadeIn>
        <SectionWithText
          title={sectionWithTextData.title}
          text={sectionWithTextData.text}
          button={sectionWithTextData.button}
          titleFontSize={sectionWithTextData.titleFontSize}
        ></SectionWithText>
      </FadeIn>
      <Products />
      <FadeIn>
        <SectionWithIcons
          sectionColor={sectionWithIconsData.sectionColor}
          titleMaxWidth={sectionWithIconsData.titleMaxWidth}
          title={sectionWithIconsData.title}
          items={sectionWithIconsData.items}
          button={sectionWithIconsData.button}
          text={sectionWithIconsData.text}
          textColor={sectionWithIconsData.textColor}
        ></SectionWithIcons>
      </FadeIn>
      <FadeIn>
        <BlocksWithIconsTwo
          items={sectionWithTwoBlocksData.items}
          align={sectionWithTwoBlocksData.align}
          title={sectionWithTwoBlocksData.title}
          text={sectionWithTwoBlocksData.text}
          button={sectionWithTwoBlocksData.button}
        />
      </FadeIn>
      <FadeIn>
        <Community />
      </FadeIn>
      {/*
   <FadeIn>
        <LatestNews />
      </FadeIn>
*/}
    </Layout>
  );
};

export default IndexPage;
